import { render, staticRenderFns } from "./Questionary.vue?vue&type=template&id=12073328&scoped=true&"
import script from "./Questionary.vue?vue&type=script&lang=js&"
export * from "./Questionary.vue?vue&type=script&lang=js&"
import style0 from "./Questionary.vue?vue&type=style&index=0&id=12073328&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12073328",
  null
  
)

export default component.exports